
// let TEST_URL = "http://localhost",
let TEST_URL = "http://192.168.1.106",
    FORMAL_URL = "https://www.ssoc.org.cn",
  isTEST = false, //是否是测试环境
  USER,
  REGISTER,
  MEETING,
  MEMBER,
  VOTE;

if (isTEST) {
  USER = TEST_URL + ":7900"; //用户论证
  REGISTER = TEST_URL + ":7901"; //注册中心
  MEETING = TEST_URL + ":7905"; //会议服务
  MEMBER = TEST_URL + ":7906"; //会员服务
  VOTE = TEST_URL + ":7917";
} else {
  USER = FORMAL_URL + "/uaa"; //用户论证
  REGISTER = FORMAL_URL + ":7901"; //注册中心
  MEETING = FORMAL_URL + "/meeting"; //会议服务
  MEMBER = FORMAL_URL + "/member"; //会员服务
  VOTE = FORMAL_URL + "/vote";

  // USER = FORMAL_URL + "/uaacs"; //用户论证
  // REGISTER = FORMAL_URL + ":8901"; //注册中心
  // MEETING = FORMAL_URL + "/meetingcs"; //会议服务
  // MEMBER = FORMAL_URL + "/membercs"; //会员服务
  // VOTE = FORMAL_URL + "/vote";
}

export {
  FORMAL_URL,
  USER,
  REGISTER,
  MEETING,
  MEMBER,
  VOTE
};